import { PresignedPostData, SelectedFile } from "./types";

export class XHRUpload {
    private presignedPostData: PresignedPostData;

    private file: SelectedFile;

    private progressNotifier: (...data: any[]) => any;

    private xhr: XMLHttpRequest;

    private formData: FormData;

    private promise: Promise<string | Event>;

    constructor(presignedPostData: PresignedPostData, file: SelectedFile, progressNotifier: (...data: any[]) => any) {
        this.presignedPostData = presignedPostData;
        this.file = file;
        this.progressNotifier = progressNotifier;

        this._createXhr();
    }

    start() {
        this.xhr.send(this.formData);
        return this.promise;
    }

    abort() {
        this.xhr.abort();
    }

    _createXhr() {
        this.promise = new Promise((resolve, reject) => {
            this.formData = new FormData();

            Object.keys(this.presignedPostData.fields).forEach(key => {
                this.formData.append(key, this.presignedPostData.fields[key]);
            });

            this.formData.append("file", this.file.src.file);

            const xhr = new XMLHttpRequest();

            // Listen to the upload progress.
            xhr.upload.onprogress = (e: ProgressEvent) => {
                this.progressNotifier(us => ({
                    ...us,
                    [this.file.name]: {
                        file: this.file,
                        status: "pending",
                        uploaded: e.loaded,
                        uploadPercent: Math.ceil((e.loaded / e.total) * 100)
                    }
                }));
            };
            xhr.addEventListener("error", reject);
            xhr.addEventListener("load", (event: ProgressEvent<any>) => {
                const currentTarget = event.currentTarget as any;

                if (currentTarget.readyState !== 4 || currentTarget.status > 299) {
                    const xmlResponse = currentTarget.responseXML;
                    const messages = xmlResponse?.getElementsByTagName("Message") ?? [];

                    if (messages.length) {
                        reject(new Error(messages[0].textContent));
                    } else {
                        reject(xmlResponse);
                    }
                    return;
                }

                resolve(event);
            });
            xhr.addEventListener("abort", () => {
                resolve("abort");
            });

            this.xhr = xhr;
            this.xhr.open("POST", this.presignedPostData.url, true);
        });
    }
}
